// extracted by mini-css-extract-plugin
export default {"modalWrap":"modal__modalWrap__sbrXF","active":"modal__active__ejD66","curtain":"modal__curtain__s5TWX","modal":"modal__modal__fOcHA","closeButton":"modal__closeButton__I0wJK"};